// services/purchases/ExcludedSubjectPurchaseService.ts
import { excludedSubjectApi } from '../../api';
import {
  ExcludedSubjectProduct,
  ExcludedSubjectProductUpdate,
} from '../../types/purchases/ExcludedSubjectPurchase';

const ExcludedSubjectPurchaseService = {
  /**
   * POST /api/excluded-subject-purchases/products
   */
  addProduct: async (product: ExcludedSubjectProduct) => {
    const response = await excludedSubjectApi.addCustom('/products', product);
    return response.data;
  },

  /**
   * PUT /api/excluded-subject-purchases/products
   */
  updateProduct: async (product: ExcludedSubjectProductUpdate) => {
    const response = await excludedSubjectApi.modifyCustom('/products', product);
    return response.data;
  },

  /**
   * DELETE /api/excluded-subject-purchases/products/{detailId}
   */
  deleteProduct: async (detailId: number) => {
    const response = await excludedSubjectApi.removeCustom(`/products/${detailId}`);
    return response.data;
  },

  /**
   * GET /api/excluded-subject-purchases/products/{detailId}
   */
  getProductById: async (detailId: number) => {
    const response = await excludedSubjectApi.fetchCustom(`/products/${detailId}`);
    return response.data;
  },
};

export default ExcludedSubjectPurchaseService;
